import * as fetchService from '../../shared/services/fetch';
import { getBasePath } from '../../shared/services/get-base-path';
import { handleError } from '../../shared/services/error-handlers';

const basePath = getBasePath();


export async function uploadBatchFactoryData ( file, uriEndpoint ) {

    // const endPoint = `${basePath}/factory-data-upload`;
    const endPoint = `${basePath}/${uriEndpoint}`;
    const formData = new FormData();
    formData.append( 'file', file );

    const options = {
        body: formData,
        method: 'POST',
    };

    try {

        const response = await fetchService.fetchforFileUpload( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );

    }
}

export async function uploadAnalysisCommentsData ( file ) {

    const endPoint = `${basePath}/analysis-comments-upload`;
    const formData = new FormData();
    formData.append( 'file', file );

    const options = {
        body: formData,
        method: 'POST',
    };

    try {

        const response = await fetchService.fetchforFileUpload( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );

    }

}

export async function uploadBatchTextData ( file ) {

    const endPoint = `${basePath}/upload-text-extract`;
    const formData = new FormData();
    formData.append( 'file', file );

    const options = {
        body: formData,
        method: 'POST',
    };

    try {

        const response = await fetchService.fetchforFileUpload( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );

    }

}
export async function uploadNonDeereClaims ( file, uriEndpoint ) {

    // const endPoint = `${basePath}/factory-data-upload`;
    const endPoint = `${basePath}/${uriEndpoint}`;
    console.log(endPoint);
    const formData = new FormData();
    formData.append( 'file', file );

    const options = {
        body: formData,
        method: 'POST',
    };

    try {

        const response = await fetchService.fetchforFileUpload( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );

    }
}